import { render, staticRenderFns } from "./MaterialColor.vue?vue&type=template&id=3c9ae8ce&"
import script from "./MaterialColor.vue?vue&type=script&lang=js&"
export * from "./MaterialColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports